export const SET_CATEGORIES = 'categories/SET_CATEGORIES';
